'use client';

import React from 'react';

export default function NoComments({
  customMessage,
  customSubtitle,
  customStyle = {},
}: {
  customMessage?: string;
  customSubtitle?: string | React.ReactNode;
  customStyle?: Record<string, string>;
}) {
  return (
    <div
      className="border border-dashed border-brand-body bg-brand-background flex flex-col justify-center items-center h-[300px] relative p-6 mb-[24px]"
      style={customStyle}
    >
      <div className="text-brand-main typography-heading-sm opacity-60 text-lg my-1">
        {customMessage || 'No comments yet'}
      </div>
      {customSubtitle || (
        <div className="text-brand-body opacity-40 typography-body-sm">
          {customSubtitle}
        </div>
      )}
      <div
        className="absolute inset-0 h-full w-full opacity-10 bg-brand-main"
      />
    </div>
  );
}
